import { useQuery } from '@tanstack/react-query';
import { getMe } from '../../infrastructure/api/usersApi';
import { useAuthStore } from '../stores/authStore';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E04 — GET /users/me; falls back to the session's embedded user while loading. */
export function useCurrentUser() {
  const sessionUser = useAuthStore((s) => s.user);
  const query = useQuery({
    queryKey: qKeys.profile,
    queryFn: getMe,
    ...queryDefaults,
    enabled: useAuthStore.getState().accessToken !== null,
  });
  return { ...query, user: query.data ?? sessionUser };
}
